import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RestrictService } from '../../../Common/Permissions/restrict.service';
import { AccountService } from '../../../User/account.service';
import { FeatureFlagsService } from 'src/app/Common/FeatureFlags/feature-flags-service';
import { UserInstanceService } from '../../../User/userInstance.service';

import * as _ from 'lodash';

@Component({
    selector: 'user-instance-permission-panel',
    templateUrl: './userInstancePermissionPanel.component.html',
    standalone: false
})
export class UserInstancePermissionPanelComponent implements OnInit, OnChanges {
    constructor(private _featureFlagsService: FeatureFlagsService,
                private _accountService: AccountService,
                private _restrictService: RestrictService,
                public userInstanceService: UserInstanceService) {
    }

    @Input() editMode: boolean;
    @Input() assignedPermissions: any[];
    @Input() userSetup: boolean;
    @Input() availablePermissions: any[];
    @Input() permissionsLookup: any;
    @Input() instanceId: number;

    permissionToAdd = null;
    uniqueScreenTypes = [];
    screenTypePermissions = [];
    featureFlags: Core.FeatureFlags;

    usablePermission = (permission) => {
        const rightHasAlreadyAssigned = !this.assignedPermissions.some(x => x.screenTypeID === permission.screenTypeID);

        const userInstanceRights = this._accountService.userData.instanceRights.find(i => i.instanceId == this.instanceId).rights.map(r => r.name);
        const rightsWithSameScreenType = this.availablePermissions.filter(ap => ap.screenTypeID == permission.screenTypeID);
        const userHasRightWithScreenTypeInThisInstance = userInstanceRights.some(r => rightsWithSameScreenType.some(s => s.name === r));

        return rightHasAlreadyAssigned && userHasRightWithScreenTypeInThisInstance;
    }

    ngOnInit(): void {
        this.featureFlags = this._featureFlagsService.featureFlags;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.availablePermissions && changes.availablePermissions.currentValue) {
            this.uniqueScreenTypes = _.uniqBy(this.availablePermissions, 'screenTypeID');
        }

        if (changes.instanceId && changes.instanceId.currentValue) {
            this.instanceId = changes.instanceId.currentValue;
        }
    }

    selectPermissionToAdd(): void {
        this.permissionToAdd = {};
    }

    cancelAddPermission(): void {
        this.permissionToAdd = null;
    }

    addPermission(): void {
        this.permissionToAdd.permission.screenTypeID = this.permissionToAdd.screenTypeID;
        this.permissionToAdd.permission.screenType = this.permissionToAdd.permission.screenType || this.getScreenType(this.permissionToAdd.screenTypeID);

        this.assignedPermissions.push(this.permissionToAdd.permission);

        this.cancelAddPermission();
    }

    getScreenType(id: number) {
        return this.availablePermissions.find(x => x.screenTypeID === id).screenType;
    }

    screenTypeSelected(id: number) {
        this.permissionToAdd.screenTypeID = id;
        this.screenTypePermissions = this.availablePermissionRights(this.permissionToAdd.screenTypeID);
        this.permissionToAdd.permission = _.minBy(this.screenTypePermissions, 'rightsID');
    }

    rightSelected(id: number, permission): void {
        permission.instanceRightID = id;
        const p = this.permissionsLookup.find(x => x.instanceRightID === permission.instanceRightID);
        permission.rights = p.rights;
        permission.rightsID = p.rightsID;
    }

    availablePermissionRights(id: number) {
        if (this.availablePermissions === undefined || this.availablePermissions.length === 0) {
            return;
        }

        return this.availablePermissions
            .filter(x => x.screenTypeID === id)
            .sort((a, b) => a.rightsID - b.rightsID);
    }

    deletePermission(permission): void {
        _.remove(this.assignedPermissions, permission);
    }

    getPermissionLabel(rightsID: number): string {
        const permission = this.permissionsLookup.find(p => p.rightsID === rightsID);

        return permission ? permission.rights : '';
    }

    userHasInstanceRight(permission): boolean {
        return this._restrictService.hasInstanceRight(permission.name, this.instanceId);
    }
}
